import Vue from 'vue'
import Vuex from 'vuex'

// Modules
import activities from './activities'
import presets from './presets'
import students from './students'
import subjects from './subjects'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    activities,
    presets,
    students,
    subjects
  }
})
